function clickbusClient<T>(method: 'GET' | 'POST', resource: string) {
  const baseUrl = 'https://api.clickbus.com/api/v3';
  return fetch(`${baseUrl}/${resource}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(async (response) => {
    const data = await response.json();
    return response.ok ? (data as T) : Promise.reject(data);
  });
}

export default clickbusClient;
